<template>
	<div>

		<button class="btn btn-sm rounded-pill" :class="btnClass" @click.prevent="onClickBtn">
			{{btnText}}
		</button>

		<transition name="fade">
			<div class="video-popup_container" v-if="showVideo">
				<div class="container h-100">
					<div class="row justify-content-center align-items-center h-100">

						<div class="col-xl-8 position-relative" style="padding-right:38px;" v-show="movie.running">
							<div class="close position-absolute" @click.prevent="closePopUp">
								<i class="fas fa-times"></i>
							</div>
							<video ref="video" controls class="w-100" @ended.prevent="videoEnded">
								<source :src="movie.src" type="video/mp4">
								Your browser does not support the video tag.
							</video>
						</div>

						<div class="col-xl-8 position-relative" style="padding-right:38px;" v-show="!movie.running">
							<div class="close position-absolute" @click.prevent="closePopUpDef">
								<i class="fas fa-times"></i>
							</div>

							<div class="row">
								<div class="col-12 text-center py-4" style="background-color:#ffffff;border-radius:1rem;">
									<h3>Il video non è finito, vuoi uscire comunque?</h3>
									<p>Per raccogliere punti finisci di guardare il video.</p>

									<button class="btn btn-yellow btn-sm rounded-pill px-2 mb-2" @click.prevent="keepWatching">
										TORNA AL VIDEO
									</button><br>
									<button class="btn btn-yellow btn-sm rounded-pill px-5" @click.prevent="closePopUpDef">
										ESCI
									</button>
								</div>
							</div>
						</div>

					</div>
				</div>
			</div>
		</transition>

	</div>
</template>

<script>
import PrivateAreaPointsMixin from './mixin/PrivateAreaPointsMixin'
import axios from 'axios'

export default {
	name: 'BtnPlayVideoComponent',
	props: ['btnClass', 'btnText', 'videoCode', 'actionType'],
	mixins: [PrivateAreaPointsMixin],

	data() {
		return {
			ajaxObj: window.ajax_object,
			showVideo: false,
			movie: {
				src: '',
				running: true,
				ended: false
			}
		}
	},

	methods: {
		onClickBtn() {
			let url = this.ajaxObj.ajax_url
			let _this = this

			axios.get(url,
				{
					params: {
						_nounce_value: this.ajaxObj._nounce_value,
						action: 'nl_retrieve_video',
						videoCode: this.videoCode,
						label: this.label
					}
				})
				.then((response) => {
					console.log(response.data.videoData.body.files)
					let ind = response.data.videoData.body.files.length
					this.movie.src = response.data.videoData.body.files[(ind - 2)].link
					this.showVideo = true
					document.getElementsByTagName("body")[0].style.overflow = 'hidden'
					setTimeout(() => {
						_this.$refs.video.play()
					}, 100)
				})
				.catch((err) => {
					console.log(err)
				})
		},

		closePopUp() {
			let _this = this
			setTimeout(() => {
				_this.$refs.video.pause()
			}, 100)
			this.movie.running = false
		},

		closePopUpDef() {
			this.showVideo = false
			this.movie.running = true
			document.getElementsByTagName("body")[0].style.overflow = 'auto'
		},

		keepWatching() {
			this.movie.running = !this.movie.running
			let _this = this
			setTimeout(() => {
				_this.$refs.video.play()
			}, 100)
		},

		videoEnded() {
			let url = this.ajaxObj.ajax_url

			var formData = new FormData();
			formData.append('action', 'nl_point_action_register')
			formData.append('_nounce_value', this.ajaxObj._nounce_value)
			formData.append('action_type', this.actionType)

			axios.post(url, formData)
				.then(() => {
					// console.log(response.data)
					this.setPrivatAreaPoints()
					this.closePopUpDef()
				}, (error) => {
					console.log(error);
				});
		}
	}
}
</script>

<style scoped>
.video-popup_container {
	position: fixed;
	top: 0;
	left: 0;
	height: 100vh;
	width: 100vw;
	background-color: rgba(0, 0, 0, 0.8);
	z-index: 9995;
}
video {
	z-index: 9999;
}
.close {
	top: -32px;
	right: 18px;
	color: #ffffff;
	cursor: pointer;
}
</style>

